const CONTACT_TYPE_OPTIONS_API = [
  {
    value: 'advisor',
    label: 'Advisor',
    tooltip:
      'A strategic relationship which may provide meaningful dealflow, portfolio support or diligence. Must have a formal legal agreement with Anthos to be an Advisor.',
  },
  {
    value: 'influencer',
    label: 'Influencer',
    tooltip:
      'Someone who can play a significant role in identifying and supporting potential investment opportunities.',
  },
  {
    value: 'contact',
    label: 'Contact',
    tooltip:
      'A person we encounter or collaborate with but who is not a primary source of either dealflow or intel.',
  },
  {
    value: 'founder',
    label: 'Founder',
    tooltip:
      'Member of leadership at a startup which might be a potential investment target. Does not strictly mean they are a member of the founding team; could also encompass "operators".',
  },
  {
    value: 'vendor',
    label: 'Vendor',
    tooltip:
      'Someone that represents a 3rd party product being sold to or actively used by Anthos.',
  },
];

export { CONTACT_TYPE_OPTIONS_API };
